export default "__VITE_ASSET__85d37236__"